import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import FontelloIcon from '@sport1/react-elements/FontelloIcon'
import SmallBodyFont from '../../../Theme/Fonts/SmallBody'
import CaptionFont from '../../../Theme/Fonts/Caption'
import { TestID } from '../../../utils/PropTypesDefinitions'
import TransferItem, { TransferItemProps } from './HelperClass/TransferItem'

export type TransferCardProps = {
    /**
     * boolean to determine if the border around the SquadPlayerItem should be hidden
     * */
    hideBorder?: boolean
    /**
     * props for the left component
     */
    leftComponentProps: TransferItemProps
    /**
     * color of the centered icon
     */
    centerIconColor: 'RED' | 'GREEN'
    /**
     * bold text to be displayed beneath the icon
     */
    centerLabel1: string
    /**
     * small text to be displayed beneath the centerLabel1
     */
    centerLabel2: string
    /**
     * props for the right component
     */
    rightComponentProps: TransferItemProps
    /**
     * to decide which image should be rendered team or player image
     * */
} & TestID

const TransferCard: FunctionComponent<TransferCardProps> = ({
    hideBorder,
    leftComponentProps,
    rightComponentProps,
    centerIconColor,
    centerLabel1,
    centerLabel2,
    testID,
}) => {
    return (
        <Grid
            noExpand
            testID={testID}
            horizontal
            borderRadius={!hideBorder ? '8px' : undefined}
            border={!hideBorder ? 1 : undefined}
            borderColor={!hideBorder ? 'moon-3' : undefined}
            backgroundColor="pearl"
            padding={4}
        >
            <TransferItem {...leftComponentProps} testID={`transfer-item-left-${testID}`} />
            <Grid width="100%" centerHorizontal noExpand paddingX={3}>
                <Grid noExpand height={24} centerVertical>
                    <FontelloIcon fontSize="13px" name="arrow-right" color={centerIconColor} />
                </Grid>
                <SmallBodyFont bold numberOfLines={1} color="onyx-5">
                    {centerLabel1}
                </SmallBodyFont>
                <CaptionFont numberOfLines={1} color="keshi-3">
                    {centerLabel2}
                </CaptionFont>
            </Grid>
            <TransferItem {...rightComponentProps} testID={`transfer-item-right-${testID}`} />
        </Grid>
    )
}

export default TransferCard
